export const GameEvents = {};

GameEvents.hasActiveEvent = () => {
  return GameEvents.chapter2EndEvent();
}

GameEvents.chapter2EndEvent = () => {
    // Czy są wszystkie Waifu
    if(!EventStateService.isJessicaWaifu) {
      return false;
    }

    if(!EventStateService.isSamanthaWaifu) {
      return false;
    }

    if(!EventStateService.vickyParkKiss) {
      return false;
    }

    if(!EventStateService.secondChapterIntro) {
      return false;
    }

    return !EventStateService.chapter2EndEvent;
}
